module.exports = __webpack_public_path__ + "img/alter-ego-mobile_en.7567b8e.jpg";